uniform float uTime;
uniform float u2D;
uniform float uSpeed;
uniform float uWarpStrength;
uniform float uPositionStrength;
uniform float uElevationStrength;

varying vec2 vUv;
varying float vElevation;

#include ../includes/simplexNoise2d.glsl

float getElevation(vec2 position)
{
    vec2 warpedPosition = position;
    warpedPosition += uTime * uSpeed;
    warpedPosition += simplexNoise2d(warpedPosition) * uWarpStrength;

    float elevation = simplexNoise2d(warpedPosition * uPositionStrength) / 2.0;
    float elevationSign = sign(elevation);

    elevation = pow(abs(elevation), 1.1) * elevationSign;
    elevation *= uElevationStrength;

    return elevation;
}

void main() {
    // Base position
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // Elevation
    float elevation = getElevation(modelPosition.xz);
    modelPosition.y = elevation * u2D;

    // Final position
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    vUv = uv;
    vElevation = elevation;
}